import { observer } from "mobx-react";
import type React from "react";
import { Navigate } from "react-router-dom";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { PRODUCT_PAGES_ROUTES, TEACHER_INSIGHT_PAGE_ROUTES } from "constants/routes";

import { useSelectedProductId } from "hooks/useSelectedProductId";

export const TeacherHomeRedirect: React.FC = observer(() => {
  const selectedProductId = useSelectedProductId();
  const buildURLWithProductIdOrFallbackToNoLicensesRoute = (path: string) =>
    selectedProductId
      ? buildUrlWithPathParams(path, { productId: `${+selectedProductId}` })
      : PRODUCT_PAGES_ROUTES.PRODUCT_LIST;

  return (
    <Navigate
      to={buildURLWithProductIdOrFallbackToNoLicensesRoute(
        TEACHER_INSIGHT_PAGE_ROUTES.PROGRESS_OVERVIEW,
      )}
      replace
    />
  );
});
